// The polished answer is the candidate's own words, followed by bracketed placeholders
// for what a stronger answer would add ("[State one sign it worked.]"). The placeholders
// are shown in their own colour so they don't melt into the answer (product owner,
// 2026-10-31). The PDF does the same (backend/pdf.py, PLACEHOLDER_COLOUR).
export function splitPlaceholders(text) {
  const parts = [];
  const re = /\[[^\]]+\]/g;
  const value = String(text || "");
  let last = 0;
  let m;
  while ((m = re.exec(value)) !== null) {
    if (m.index > last) parts.push({ text: value.slice(last, m.index), placeholder: false });
    parts.push({ text: m[0], placeholder: true });
    last = m.index + m[0].length;
  }
  if (last < value.length) parts.push({ text: value.slice(last), placeholder: false });
  return parts;
}
